<h1 mat-dialog-title>{{'components.createProgramDialog.titleCreateProgram' | translate}}</h1>
<div mat-dialog-content>
  <p>{{'components.createProgramDialog.name' | translate}}</p>
  <mat-form-field class='pgFormInput'>
    <input matInput required [(ngModel)]="data.name">
  </mat-form-field>
  <p>{{'components.createProgramDialog.description' | translate}}</p>
  <mat-form-field class='pgFormInput'>
    <textarea matInput required [(ngModel)]="data.description"></textarea>
  </mat-form-field>
  <p>{{'components.createProgramDialog.type' | translate}}</p>
  <mat-form-field class='pgFormInput'>
    <mat-select matInput required [(ngModel)]="data.type"
      placeholder="{{'components.createProgramDialog.selectTypePlaceholder' | translate}}">
      <mat-option value="JIRA Agile">
        JIRA Agile
      </mat-option>
      <mat-option value="JIRA Cloud">
        JIRA Cloud
      </mat-option>
    </mat-select>
  </mat-form-field>
  <p>{{'components.createProgramDialog.url' | translate}}</p>
  <mat-form-field class='pgFormInput'>
    <input matInput required [(ngModel)]="data.url" />
  </mat-form-field>
  <p>{{'components.createProgramDialog.user' | translate}}</p>
  <mat-form-field class='pgFormInput'>
    <input matInput required [(ngModel)]="data.user" />
  </mat-form-field>
  <p>{{'components.createProgramDialog.pass' | translate}}</p>
  <mat-form-field class='pgFormInput'>
    <input type="password" matInput required [(ngModel)]="data.pass" />
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button [disabled]="!data.name || !data.description"
    [mat-dialog-close]="data">{{'components.createProgramDialog.create' | translate}}</button>
  <button mat-button (click)="cancel()">{{'components.createProgramDialog.cancel' | translate}}</button>
</div>